import React from 'react';
import LocationTemplate from './LocationTemplate';

const AvonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Avon"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27915"]}
      latitude={35.3518}
      longitude={-75.5032}
      population={776}
      historicalFact="Originally called Kinnakeet after a Native American village, renamed Avon in 1883."
      nearbyTowns={[
        "Buxton, NC",
        "Salvo, NC",
        "Frisco, NC",
        "Rodanthe, NC",
        "Waves, NC",
        "Hatteras, NC",
        "Cape Hatteras, NC",
        "Chicamacomico, NC"
      ]}
    />
  );
};

export default AvonPage;